//? Management permissions
export const LEAD_AUTH = 'LEAD_AUTH';
export const SERVICE_CLIENT_AUTH = 'SERVICE_CLIENT_AUTH';
export const CONTACT_AUTH = 'CONTACT_AUTH';
export const SOURCE_AUTH = 'SOURCE_AUTH';
export const TAGS_AUTH = 'TAGS_AUTH';
export const MAKE_AUTH = 'MAKE_AUTH';
export const VEHICLES_AUTH = 'VEHICLES_AUTH';
export const USER_AUTH = 'USER_AUTH';
export const IMPERSONATE_USER_AUTH = 'IMPERSONATE_USER_AUTH';
export const TEMPERATURES_AUTH = 'TEMPERATURES_AUTH';
export const RECORDINGS_AUTH = 'RECORDINGS_AUTH';
export const INVOICES_AUTH = 'INVOICES_AUTH';
export const EVALUATION_AUTH = 'EVALUATION_AUTH';
export const PERMISSIONS_AUTH = 'PERMISSIONS_AUTH';
export const PRESENTATION_CARD_AUTH = 'PRESENTATION_CARD_AUTH';
export const VERSIONS_AUTH = 'VERSIONS_AUTH';
export const INTEGRATIONS_VEHICLE_AUTH = 'INTEGRATIONS_VEHICLE_AUTH';
export const AD_CAMPAIGN_AUTH = 'AD_CAMPAIGN_AUTH';
export const LEAD_BDC_AUTH = 'LEAD_BDC_AUTH';
export const CATALOGUE_AUTH = 'CATALOGUE_AUTH';
export const CHATBOT_AUTH = 'CHATBOT_AUTH';
export const DOCUMENTS_AUTH = 'DOCUMENTS_AUTH';
export const FINANCIAL_INSTITUTIONS_AUTH = 'FINANCIAL_INSTITUTIONS_AUTH';
export const GROUPS_AUTH = 'GROUPS_AUTH';
export const STORE_GROUP_PERMISSION = 'STORE_GROUP_PERMISSION';
export const INVESTMENTS_CHART_AUTH = 'INVESTMENTS_CHART_AUTH';
export const LEAD_SHOWROOM_AUTH = 'LEAD_SHOWROOM_AUTH';
export const TASKS_AUTH = 'TASKS_AUTH';
export const STORES_RECORDINGS_AUTH = 'STORES_RECORDINGS_AUTH';
export const AUTOMATIC_MAILING_AUTH = 'AUTOMATIC_MAILING_AUTH';
export const RECORDING_TESTS_AUTH = 'RECORDING_TESTS_AUTH';
export const STATUS_AUTH = 'STATUS_AUTH';
export const TEMPLATES_WSP_AUTH = 'TEMPLATES_WSP_AUTH';
export const CONVERSATIONS_AUTH = 'CONVERSATIONS_AUTH';
export const WARBOX_CONVERSATIONS_AUTH = 'WARBOX_CONVERSATIONS_AUTH';
export const EMAIL_MARKETING_AUTH = 'EMAIL_MARKETING_AUTH';
export const SUBSCRIPTIONS_AUTH = 'SUBSCRIPTIONS_AUTH';
export const MAINTENANCE_PACKAGE_AUTH = 'MAINTENANCE_PACKAGE_AUTH';
export const NOTE_CONVERSATION_AUTH = 'NOTE_CONVERSATION_AUTH';

//? Store permissions
export const STORE_AUTH = 'STORE_AUTH';
export const STORE_CREDIT_AUTH = 'STORE_CREDIT_AUTH';
export const STORE_PLUGINS_AUTH = 'STORE_PLUGINS_AUTH';
export const STORE_TAX_AUTH = 'STORE_TAX_AUTH';
export const STORE_VIDEO_MAILING_AUTH = 'STORE_VIDEO_MAILING_AUTH';
export const STORE_EXTERNAL_REFERENCES_AUTH = 'STORE_EXTERNAL_REFERENCES_AUTH';
export const STORE_AREAS_AUTH = 'STORE_AREAS_AUTH';
export const STORE_INTEGRATIONS_STATUS_AUTH = 'STORE_INTEGRATIONS_STATUS_AUTH';
export const STORE_TWILIO_CALLS_AUTH = 'STORE_TWILIO_CALLS_AUTH';
export const STORE_GOALS_AUTH = 'STORE_GOALS_AUTH';
export const AI_CALL_AUTH = 'AI_CALL_AUTH';

//? Dashboard permissions
export const DASHBOARD_GENERAL_REPORT_AUTH = 'DASHBOARD_GENERAL_REPORT_AUTH';
export const DASHBOARD_GOALS_REPORT_AUTH = 'DASHBOARD_GOALS_REPORT_AUTH';
export const DASHBOARD_APPOINTMENTS_REPORT_AUTH =
    'DASHBOARD_APPOINTMENTS_REPORT_AUTH';
export const DASHBOARD_VISITS_REPORT_AUTH = 'DASHBOARD_VISITS_REPORT_AUTH';
export const DASHBOARD_SALES_REPORT_AUTH = 'DASHBOARD_SALES_REPORT_AUTH';

//? Calendar permissions
export const LEAD_APPOINTMENTS_CALENDAR_AUTH =
    'LEAD_APPOINTMENTS_CALENDAR_AUTH';
export const BDC_APPOINTMENTS_CALENDAR_AUTH = 'BDC_APPOINTMENTS_CALENDAR_AUTH';
export const LEAD_TASKS_CALENDAR_AUTH = 'LEAD_TASKS_CALENDAR_AUTH';
export const BDC_TASKS_CALENDAR_AUTH = 'BDC_TASKS_CALENDAR_AUTH';

//? Config permissions
export const ASSIGN_AGENT_AUTH = 'ASSIGN_AGENT_AUTH';
export const AUTO_ASSIGN_CAROUSEL_AUTH = 'AUTO_ASSIGN_CAROUSEL_AUTH';
export const TICKETS_RATING_AUTH = 'TICKETS_RATING_AUTH';
export const PAYMENT_AUTH = 'PAYMENT_AUTH';
export const FACEBOOK_ADS_AUTH = 'FACEBOOK_ADS_AUTH';
export const REJECT_LEAD_AUTH = 'REJECT_LEAD_AUTH';
export const ASSIGN_WHATSAPP_CONVERSATION_AUTH =
    'ASSIGN_WHATSAPP_CONVERSATION_AUTH';
export const UPLOAD_LEADS_AUTH = 'UPLOAD_LEADS_AUTH';
export const DUPLICATED_LEAD_AUTH = 'DUPLICATED_LEAD_AUTH';
export const BDC_AUTH = 'BDC_AUTH';

//? Reports in dashboards
export const DASHBOARD_LEADS_BY_STORE_REPORT_AUTH =
    'DASHBOARD_LEADS_BY_STORE_REPORT_AUTH';

export const DASHBOARD_APPOINTMENTS_BY_STORE_REPORT_AUTH =
    'DASHBOARD_APPOINTMENTS_BY_STORE_REPORT_AUTH';

export const DASHBOARD_VISITS_BY_STORE_REPORT_AUTH =
    'DASHBOARD_VISITS_BY_STORE_REPORT_AUTH';

export const DASHBOARD_SALES_BY_STORE_REPORT_AUTH =
    'DASHBOARD_SALES_BY_STORE_REPORT_AUTH';

export const DASHBOARD_TOTALS_GENERAL_REPORT_AUTH =
    'DASHBOARD_TOTALS_GENERAL_REPORT_AUTH';

export const DASHBOARD_LEADS_PER_DAY_REPORT_AUTH =
    'DASHBOARD_LEADS_PER_DAY_REPORT_AUTH';

export const DASHBOARD_FINANCIAL_INSTITUTION_PIE_REPORT_AUTH =
    'DASHBOARD_FINANCIAL_INSTITUTION_PIE_REPORT_AUTH';

export const DASHBOARD_SALES_TOP_USERS_REPORT_AUTH =
    'DASHBOARD_SALES_TOP_USERS_REPORT_AUTH';

export const DASHBOARD_AGENTS_CALLS_REPORT_AUTH =
    'DASHBOARD_AGENTS_CALLS_REPORT_AUTH';

export const DASHBOARD_LEADS_BY_SUBSTATUS_REPORT_AUTH =
    'DASHBOARD_LEADS_BY_SUBSTATUS_REPORT_AUTH';

export const DASHBOARD_APPOINTMENTS_BY_SUBSTATUS_REPORT_AUTH =
    'DASHBOARD_APPOINTMENTS_BY_SUBSTATUS_REPORT_AUTH';

export const DASHBOARD_APPOINTMENTS_BY_WEEK_DAYS_REPORT_AUTH =
    'DASHBOARD_APPOINTMENTS_BY_WEEK_DAYS_REPORT_AUTH';

export const DASHBOARD_VISITS_BY_SUBSTATUS_REPORT_AUTH =
    'DASHBOARD_VISITS_BY_SUBSTATUS_REPORT_AUTH';

export const DASHBOARD_VISITS_BY_WEEK_DAYS_REPORT_AUTH =
    'DASHBOARD_VISITS_BY_WEEK_DAYS_REPORT_AUTH';

export const DASHBOARD_OPERATION_TYPE_CHART_REPORT_AUTH =
    'DASHBOARD_OPERATION_TYPE_CHART_REPORT_AUTH';

export const DASHBOARD_PROFIT_MODEL_CHART_REPORT_AUTH =
    'DASHBOARD_PROFIT_MODEL_CHART_REPORT_AUTH';

export const DASHBOARD_PROFIT_STORE_CHART_REPORT_AUTH =
    'DASHBOARD_PROFIT_STORE_CHART_REPORT_AUTH';

export const DASHBOARD_WEEKLY_PROFIT_CHART_REPORT_AUTH =
    'DASHBOARD_WEEKLY_PROFIT_CHART_REPORT_AUTH';

export const DASHBOARD_PROFIT_BY_TIME_REPORT_AUTH =
    'DASHBOARD_PROFIT_BY_TIME_REPORT_AUTH';

export const DASHBOARD_GOALS_BY_TEMPERATURE_FUNNEL_REPORT_AUTH =
    'DASHBOARD_GOALS_BY_TEMPERATURE_FUNNEL_REPORT_AUTH';

export const DASHBOARD_GOALS_BY_FOLLOW_UP_FUNNEL_REPORT_AUTH =
    'DASHBOARD_GOALS_BY_FOLLOW_UP_FUNNEL_REPORT_AUTH';

export const DASHBOARD_GENERAL_TABLE_REPORT_AUTH =
    'DASHBOARD_GENERAL_TABLE_REPORT_AUTH';

export const DASHBOARD_BY_FOLLOW_UP_AND_SOURCES_REPORT_AUTH =
    'DASHBOARD_BY_FOLLOW_UP_AND_SOURCES_REPORT_AUTH';

export const DASHBOARD_DRILLDOWN_GOALS_BY_FOLLOW_UP_REPORT_AUTH =
    'DASHBOARD_DRILLDOWN_GOALS_BY_FOLLOW_UP_REPORT_AUTH';

//? Drilldown reports
//* /drilldowns/appointment-detailed-analysis
export const DRILLDOWN_APPOINTMENTS_DETAILED_ANALYSIS_REPORT_AUTH =
    'DRILLDOWN_APPOINTMENTS_DETAILED_ANALYSIS_REPORT_AUTH';

//* /drilldowns/global-prospecting-by-temperature
export const DRILLDOWN_GLOBAL_PROSPECTING_BY_TEMPERATURE_REPORT_AUTH =
    'DRILLDOWN_GLOBAL_PROSPECTING_BY_TEMPERATURE_REPORT_AUTH';

//* /drilldowns/global-prospecting-by-sources
export const DRILLDOWN_GLOBAL_PROSPECTING_BY_SOURCES_REPORT_AUTH =
    'DRILLDOWN_GLOBAL_PROSPECTING_BY_SOURCES_REPORT_AUTH';

//* /drilldowns/prospecting-by-agents
export const DRILLDOWN_PROSPECTING_BY_AGENTS_REPORT_AUTH =
    'DRILLDOWN_PROSPECTING_BY_AGENTS_REPORT_AUTH';

//* /drilldowns/sales-detailed-analysis
export const DRILLDOWN_SALES_DETAILED_ANALYSIS_REPORT_AUTH =
    'DRILLDOWN_SALES_DETAILED_ANALYSIS_REPORT_AUTH';

//* /drilldowns/leads-without-assignment
export const DRILLDOWN_LEADS_WITHOUT_ASSIGNMENT_REPORT_AUTH =
    'DRILLDOWN_LEADS_WITHOUT_ASSIGNMENT_REPORT_AUTH';

//* /drilldowns/visits-detailed-analysis
export const DRILLDOWN_VISITS_DETAILED_ANALYSIS_REPORT_AUTH =
    'DRILLDOWN_VISITS_DETAILED_ANALYSIS_REPORT_AUTH';

//* /drilldowns/calls-detailed-analysis
export const DRILLDOWN_CALLS_DETAILED_ANALYSIS_REPORT_AUTH =
    'DRILLDOWN_CALLS_DETAILED_ANALYSIS_REPORT_AUTH';

//? Tables reports
//* /reports/call-performance
export const TABLE_CALL_PERFORMANCE_REPORT_AUTH =
    'TABLE_CALL_PERFORMANCE_REPORT_AUTH';

//* /reports/prospecting-models
export const TABLE_PROSPECTING_MODELS_REPORT_AUTH =
    'TABLE_PROSPECTING_MODELS_REPORT_AUTH';

//* /reports/prospecting-sources
export const TABLE_PROSPECTING_SOURCES_REPORT_AUTH =
    'TABLE_PROSPECTING_SOURCES_REPORT_AUTH';

//* /reports/ai-calls
export const TABLE_AI_CALLS_REPORT_AUTH = 'TABLE_AI_CALLS_REPORT_AUTH';

//* /reports/warbox-messages
export const REPORT_WARBOX_MESSAGES_ANALYTICS =
    'REPORT_WARBOX_MESSAGES_ANALYTICS';

//* /reports/prospecting-total
export const TABLE_PROSPECTING_TOTAL = 'TABLE_PROSPECTING_TOTAL';

//* /reports/prospecting-agents-sources
export const TABLE_PROSPECTING_AGENT_SOURCES_REPORT_AUTH =
    'TABLE_PROSPECTING_AGENT_SOURCES_REPORT_AUTH';

//* /reports/prospecting-agencies
export const TABLE_PROSPECTING_AGENCIES_REPORT_AUTH =
    'TABLE_PROSPECTING_AGENCIES_REPORT_AUTH';

//* /reports/agents-comparative
export const TABLE_AGENTS_COMPARATIVE_REPORT_AUTH =
    'TABLE_AGENTS_COMPARATIVE_REPORT_AUTH';

//* /internal/addons-usage
export const TABLE_ADDONS_USAGE_REPORT_AUTH = 'TABLE_ADDONS_USAGE_REPORT_AUTH';

//* /reports/agents-calls
export const TABLE_AGENTS_CALLS_REPORT_AUTH = 'TABLE_AGENTS_CALLS_REPORT_AUTH';

//* /reports/temperatures-substatus
export const TABLE_TEMPERATURES_SUBSTATUS_REPORT_AUTH =
    'TABLE_TEMPERATURES_SUBSTATUS_REPORT_AUTH';

//* /internal/extra-scores
export const TABLE_EXTRA_SCORES_REPORT_AUTH = 'TABLE_EXTRA_SCORES_REPORT_AUTH';

//* /reports/stores-score
export const TABLE_STORES_SCORES_REPORT_AUTH =
    'TABLE_STORES_SCORES_REPORT_AUTH';

//* /reports/follow-up-time
export const TABLE_FOLLOW_UP_TIME_REPORT_AUTH =
    'TABLE_FOLLOW_UP_TIME_REPORT_AUTH';

//* /reports/follow-up-response-time
export const TABLE_FOLLOW_UP_RESPONSE_TIME_REPORT_AUTH =
    'TABLE_FOLLOW_UP_RESPONSE_TIME_REPORT_AUTH';

//* /reports/follow-up-by-agents
export const TABLE_FOLLOW_UP_BY_AGENTS_REPORT_AUTH =
    'TABLE_FOLLOW_UP_BY_AGENTS_REPORT_AUTH';

//* /reports/pending-tasks-by-agencies
export const TABLE_PENDING_TASKS_BY_AGENCIES_REPORT_AUTH =
    'TABLE_PENDING_TASKS_BY_AGENCIES_REPORT_AUTH';

//* /reports/prospects-with-visits
export const TABLE_PROSPECTS_WITH_VISITS_REPORT_AUTH =
    'TABLE_PROSPECTS_WITH_VISITS_REPORT_AUTH';

//* /reports/investments-by-campaigns
export const TABLE_INVESTMENTS_BY_CAMPAIGNS_REPORT_AUTH =
    'TABLE_INVESTMENTS_BY_CAMPAIGNS_REPORT_AUTH';

//? Charts reports
//* /charts/prospecting-by-date-and-model
export const CHART_PROSPECTING_BY_DATE_AND_MODEL_REPORT_AUTH =
    'CHART_PROSPECTING_BY_DATE_AND_MODEL_REPORT_AUTH';

//* /charts/master-report
export const CHART_MASTER_REPORT_AUTH = 'CHART_MASTER_REPORT_AUTH';

//* /charts/funnel-status-by-temperature
export const CHART_FUNNEL_STATUS_BY_TEMPERATURE_REPORT_AUTH =
    'CHART_FUNNEL_STATUS_BY_TEMPERATURE_REPORT_AUTH';

//* /charts/prospecting-by-hours
export const CHART_PROSPECTING_BY_HOURS_REPORT_AUTH =
    'CHART_PROSPECTING_BY_HOURS_REPORT_AUTH';

//* /charts/funnel-prospecting-by-status
export const CHART_FUNNEL_BY_PROSPECTING_STATUS_REPORT_AUTH =
    'CHART_FUNNEL_BY_PROSPECTING_STATUS_REPORT_AUTH';

//CRUD
export const CREATE_PERMISSION = 'create';
export const READ_PERMISSION = 'read';
export const UPDATE_PERMISSION = 'update';
export const DELETE_PERMISSION = 'delete';

export const MANAGEMENT_PERMISSIONS = [
    LEAD_AUTH,
    LEAD_BDC_AUTH,
    LEAD_SHOWROOM_AUTH,
    SERVICE_CLIENT_AUTH,
    CONTACT_AUTH,
    PRESENTATION_CARD_AUTH,
    CONVERSATIONS_AUTH,
    WARBOX_CONVERSATIONS_AUTH,
    SOURCE_AUTH,
    STORE_AUTH,
    TAGS_AUTH,
    MAKE_AUTH,
    VEHICLES_AUTH,
    TEMPERATURES_AUTH,
    RECORDINGS_AUTH,
    INVOICES_AUTH,
    PERMISSIONS_AUTH,
    VERSIONS_AUTH,
    INTEGRATIONS_VEHICLE_AUTH,
    AD_CAMPAIGN_AUTH,
    CATALOGUE_AUTH,
    CHATBOT_AUTH,
    DOCUMENTS_AUTH,
    FINANCIAL_INSTITUTIONS_AUTH,
    GROUPS_AUTH,
    INVESTMENTS_CHART_AUTH,
    TASKS_AUTH,
    STORES_RECORDINGS_AUTH,
    STORE_GROUP_PERMISSION,
    AUTOMATIC_MAILING_AUTH,
    RECORDING_TESTS_AUTH,
    STATUS_AUTH,
    TEMPLATES_WSP_AUTH,
    USER_AUTH,
    IMPERSONATE_USER_AUTH,
    EVALUATION_AUTH,
    EMAIL_MARKETING_AUTH,
    MAINTENANCE_PACKAGE_AUTH,
    NOTE_CONVERSATION_AUTH,
];

export const STORES_PERMISSIONS = [
    STORE_AUTH,
    AI_CALL_AUTH,
    STORE_AREAS_AUTH,
    STORE_INTEGRATIONS_STATUS_AUTH,
    STORE_CREDIT_AUTH,
    STORE_PLUGINS_AUTH,
    STORE_TAX_AUTH,
    STORE_VIDEO_MAILING_AUTH,
    STORE_EXTERNAL_REFERENCES_AUTH,
    STORE_TWILIO_CALLS_AUTH,
    STORE_GOALS_AUTH,
];

export const GENERAL_DASHBOARD_PERMISSIONS = [
    DASHBOARD_GENERAL_REPORT_AUTH,
    DASHBOARD_LEADS_BY_STORE_REPORT_AUTH,
    DASHBOARD_APPOINTMENTS_BY_STORE_REPORT_AUTH,
    DASHBOARD_VISITS_BY_STORE_REPORT_AUTH,
    DASHBOARD_SALES_BY_STORE_REPORT_AUTH,
    DASHBOARD_TOTALS_GENERAL_REPORT_AUTH,
    DASHBOARD_LEADS_PER_DAY_REPORT_AUTH,
    DASHBOARD_FINANCIAL_INSTITUTION_PIE_REPORT_AUTH,
    DASHBOARD_SALES_TOP_USERS_REPORT_AUTH,
    DASHBOARD_AGENTS_CALLS_REPORT_AUTH,
    DASHBOARD_LEADS_BY_SUBSTATUS_REPORT_AUTH,
];

export const APPOINTMENTS_DASHBOARD_PERMISSIONS = [
    DASHBOARD_APPOINTMENTS_REPORT_AUTH,
    DASHBOARD_APPOINTMENTS_BY_STORE_REPORT_AUTH,
    DASHBOARD_APPOINTMENTS_BY_SUBSTATUS_REPORT_AUTH,
    DASHBOARD_APPOINTMENTS_BY_WEEK_DAYS_REPORT_AUTH,
];

export const VISITS_DASHBOARD_PERMISSIONS = [
    DASHBOARD_VISITS_REPORT_AUTH,
    DASHBOARD_VISITS_BY_STORE_REPORT_AUTH,
    DASHBOARD_VISITS_BY_SUBSTATUS_REPORT_AUTH,
    DASHBOARD_VISITS_BY_WEEK_DAYS_REPORT_AUTH,
];

export const SALES_DASHBOARD_PERMISSIONS = [
    DASHBOARD_SALES_REPORT_AUTH,
    DASHBOARD_TOTALS_GENERAL_REPORT_AUTH,
    DASHBOARD_PROFIT_BY_TIME_REPORT_AUTH,
    DASHBOARD_WEEKLY_PROFIT_CHART_REPORT_AUTH,
    DASHBOARD_PROFIT_STORE_CHART_REPORT_AUTH,
    DASHBOARD_PROFIT_MODEL_CHART_REPORT_AUTH,
    DASHBOARD_OPERATION_TYPE_CHART_REPORT_AUTH,
    DASHBOARD_SALES_BY_STORE_REPORT_AUTH,
    DASHBOARD_FINANCIAL_INSTITUTION_PIE_REPORT_AUTH,
];

export const REPORTS_PERMISSIONS = [
    DASHBOARD_GOALS_REPORT_AUTH,
    DASHBOARD_GOALS_BY_TEMPERATURE_FUNNEL_REPORT_AUTH,
    DASHBOARD_GOALS_BY_FOLLOW_UP_FUNNEL_REPORT_AUTH,
    DASHBOARD_GENERAL_TABLE_REPORT_AUTH,
    DASHBOARD_BY_FOLLOW_UP_AND_SOURCES_REPORT_AUTH,
    DASHBOARD_DRILLDOWN_GOALS_BY_FOLLOW_UP_REPORT_AUTH,

    TABLE_CALL_PERFORMANCE_REPORT_AUTH,
    TABLE_PROSPECTING_MODELS_REPORT_AUTH,
    TABLE_PROSPECTING_SOURCES_REPORT_AUTH,
    TABLE_AI_CALLS_REPORT_AUTH,
    REPORT_WARBOX_MESSAGES_ANALYTICS,
    TABLE_PROSPECTING_TOTAL,
    TABLE_PROSPECTING_AGENT_SOURCES_REPORT_AUTH,
    TABLE_PROSPECTING_AGENCIES_REPORT_AUTH,
    TABLE_AGENTS_COMPARATIVE_REPORT_AUTH,
    TABLE_ADDONS_USAGE_REPORT_AUTH,
    TABLE_AGENTS_CALLS_REPORT_AUTH,
    TABLE_TEMPERATURES_SUBSTATUS_REPORT_AUTH,
    TABLE_EXTRA_SCORES_REPORT_AUTH,
    TABLE_STORES_SCORES_REPORT_AUTH,
    TABLE_FOLLOW_UP_TIME_REPORT_AUTH,
    TABLE_FOLLOW_UP_RESPONSE_TIME_REPORT_AUTH,
    TABLE_PENDING_TASKS_BY_AGENCIES_REPORT_AUTH,
    TABLE_PROSPECTS_WITH_VISITS_REPORT_AUTH,
    TABLE_INVESTMENTS_BY_CAMPAIGNS_REPORT_AUTH,
    TABLE_FOLLOW_UP_BY_AGENTS_REPORT_AUTH,

    CHART_MASTER_REPORT_AUTH,
    CHART_PROSPECTING_BY_DATE_AND_MODEL_REPORT_AUTH,
    CHART_PROSPECTING_BY_HOURS_REPORT_AUTH,
    CHART_FUNNEL_BY_PROSPECTING_STATUS_REPORT_AUTH,
    CHART_FUNNEL_STATUS_BY_TEMPERATURE_REPORT_AUTH,

    DRILLDOWN_APPOINTMENTS_DETAILED_ANALYSIS_REPORT_AUTH,
    DRILLDOWN_GLOBAL_PROSPECTING_BY_TEMPERATURE_REPORT_AUTH,
    DRILLDOWN_GLOBAL_PROSPECTING_BY_SOURCES_REPORT_AUTH,
    DRILLDOWN_PROSPECTING_BY_AGENTS_REPORT_AUTH,
    DRILLDOWN_SALES_DETAILED_ANALYSIS_REPORT_AUTH,
    DRILLDOWN_LEADS_WITHOUT_ASSIGNMENT_REPORT_AUTH,
    DRILLDOWN_VISITS_DETAILED_ANALYSIS_REPORT_AUTH,
    DRILLDOWN_CALLS_DETAILED_ANALYSIS_REPORT_AUTH,
];

export const CALENDARS_PERMISSIONS = [
    LEAD_APPOINTMENTS_CALENDAR_AUTH,
    BDC_APPOINTMENTS_CALENDAR_AUTH,
    LEAD_TASKS_CALENDAR_AUTH,
    BDC_TASKS_CALENDAR_AUTH,
];

export const CONFIG_PERMISSIONS = [
    ASSIGN_AGENT_AUTH,
    TICKETS_RATING_AUTH,
    AUTO_ASSIGN_CAROUSEL_AUTH,
    FACEBOOK_ADS_AUTH,
    REJECT_LEAD_AUTH,
    ASSIGN_WHATSAPP_CONVERSATION_AUTH,
    DUPLICATED_LEAD_AUTH,
    BDC_AUTH,
    UPLOAD_LEADS_AUTH,
    SUBSCRIPTIONS_AUTH,
];

export const PERMISSIONS = [
    ...MANAGEMENT_PERMISSIONS,
    ...STORES_PERMISSIONS,
    ...GENERAL_DASHBOARD_PERMISSIONS,
    ...APPOINTMENTS_DASHBOARD_PERMISSIONS,
    ...VISITS_DASHBOARD_PERMISSIONS,
    ...SALES_DASHBOARD_PERMISSIONS,
    ...REPORTS_PERMISSIONS,
    ...CALENDARS_PERMISSIONS,
    ...CONFIG_PERMISSIONS,
];

export type TPermissionKey = (typeof PERMISSIONS)[number];
